import { FeedbackConversation } from "../../../components/BrieChatMenu/BrieChatFeedback";
import API from "../../../api/api/API";
import { useQuery } from "@tanstack/react-query";

const useFeedbackConversation = (feedbackId: string) => {
  const conversation = useQuery({
    queryKey: ["feedbackConversation", feedbackId],
    queryFn: () =>
      API.getFeedbackConversation(feedbackId).then((data) => data.data.data),
    enabled: !!feedbackId,
  });

  return {
    conversation: conversation.data as FeedbackConversation,
    conversationLoading: conversation.isLoading,
  };
};

export default useFeedbackConversation;
